// import logo from './logo.svg';
import { Toaster } from 'react-hot-toast';
import './App.css';
import AllRoutes from './Routes/AllRoutes';
import { useLogout, LogoutProvider } from './context/LogoutContext';
import Logout from './Pages/Auth/Logout';
import { BrowserRouter } from 'react-router-dom';

function LogoutDialog() {
  const { isLogoutDialogOpen, closeLogoutDialog } = useLogout()

  return isLogoutDialogOpen ? (
    <Logout
      isOpen={isLogoutDialogOpen}
      onClose={closeLogoutDialog}
    />
  ) : null
}

function App() {
  return (
    <BrowserRouter>
      <LogoutProvider>
        <div id="app">
          <AllRoutes />
          <Toaster />
          <LogoutDialog />
        </div>
      </LogoutProvider>
    </BrowserRouter>
  );
}

export default App;
